export { default as distanceInWord } from './distanceInWord';
export { default as distanceInWordStrict } from './distanceInWordStrict';
export { default as distanceInWordToNow } from './distanceInWordToNow';
export { default as formatDate } from './formatDate';